/**
 * Small info strip listing supported import + export formats — makes the
 * demo look like the real product surface. All formats listed are ones the
 * production MAPTRIUM pipeline actually supports; the demo only performs a
 * PDF export today.
 */
export default function FormatsStrip() {
  const imports = ['CSV', 'XLSX', 'KML', 'GeoJSON', 'Shapefile'];
  const exports_ = ['PDF', 'DOCX', 'PPTX', 'PNG', 'GeoJSON', 'AGOL', 'TAK'];

  return (
    <div className="card p-4">
      <div className="text-xs uppercase tracking-wider text-atlas-muted mb-3">
        Formats supported in MAPTRIUM
      </div>
      <div className="grid grid-cols-2 gap-3 text-sm">
        <div>
          <div className="text-xs font-semibold text-atlas-ink mb-1.5">Import</div>
          <div className="flex flex-wrap gap-1">
            {imports.map((f) => (
              <span
                key={f}
                className="text-[11px] font-medium px-2 py-0.5 rounded bg-atlas-paper text-atlas-ink border border-atlas-line"
              >
                {f}
              </span>
            ))}
          </div>
        </div>
        <div>
          <div className="text-xs font-semibold text-atlas-ink mb-1.5">Export</div>
          <div className="flex flex-wrap gap-1">
            {exports_.map((f) => (
              <span
                key={f}
                className="text-[11px] font-medium px-2 py-0.5 rounded bg-atlas-navy text-white"
              >
                {f}
              </span>
            ))}
          </div>
        </div>
      </div>
      <p className="mt-3 text-[11px] text-atlas-muted">
        Demo exports PDF only. All others enabled in the full product at maptrium.com.
      </p>
    </div>
  );
}
